import { JoinWaitingListDTO, NotificationSubscription, TicketSetting } from '../types';
import { axiosInstance, endpoints } from '../utils/axios';

export async function isInWaitingList(eventId: number): Promise<boolean> {
  const response = await axiosInstance.get<boolean>(endpoints.waitingList.isInWaitingList(eventId));
  return response.data;
}

export async function joinWaitingList(
  eventId: number,
  payload: JoinWaitingListDTO
): Promise<NotificationSubscription> {
  const response = await axiosInstance.post<NotificationSubscription>(
    endpoints.waitingList.join(eventId),
    payload
  );

  return response.data;
}

export async function leaveWaitingList(eventId: number): Promise<void> {
  await axiosInstance.delete(endpoints.waitingList.leave(eventId));
}

export async function getWaitingListTickets(eventId: number): Promise<TicketSetting[]> {
  const response = await axiosInstance.get<TicketSetting[]>(
    endpoints.tickets.waitingListTickets(eventId)
  );
  return response.data;
}
